import React, { useState } from "react";
import Typed from "react-typed";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";
import { Card, Col, Container, Row, Modal } from "react-bootstrap";
import { FiList, FiX } from "react-icons/fi";
import Header from "./Header";
import RetroBackground from "./RetroBackground";

library.add(fab, far, fas);

const HeroSection = () => {
  const typedStrings = [
    "Information Engineering Graduand",
    " Software Engineer",
    " Tutor",
    " Freelancer",
    " Photographer",
    " Footballer",
    " Gamer",
  ];

  const [showModal, setShowModal] = useState(false);

  const handleIconClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);

  const handleMobileNavToggle = () => {
    setIsMobileNavActive(!isMobileNavActive);
  };
  return (
    <>
      <section
        id="hero"
        className="d-flex flex-column justify-content-center align-items-center App-header"
      >
        <div className="hero-container text-center " data-aos="fade-in">
          <h1 style={{ fontWeight: "bold" }}>Isaiah Chiraira</h1>
          <p>
            <Typed strings={typedStrings} typeSpeed={40} backSpeed={50} loop />
          </p>
        </div>
        <div style={{ fontSize: "4rem" }} className="gradient-text">
          <FontAwesomeIcon
            icon={faCirclePlay}
            className="fa-beat"
            onClick={handleIconClick}
          />
        </div>
      </section>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Body className="d-flex justify-content-center flex-column">
          <p className="text-center"> Take a look at what I build for fun</p>
          <iframe
            src="https://player.cloudinary.com/embed/?public_id=fun_d23vlh&cloud_name=duma2aru7&player[skin]=light"
            allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
            allowFullScreen
            height="450"
            width="auto"
            frameBorder="0"
            controls={false}
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HeroSection;
